import CityPageTemplate from "../city-template/CityPageTemplate";
import { laramieConfig } from "./data";

export default function LaramiePage() {
  return <CityPageTemplate config={laramieConfig} />;
}